if (!customElements.get('registration-lookup')) {
  class ComponentRegistrationLookup extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.resultsContainer = this.querySelector('#registration-lookup-results');
      this.template = this.querySelector('template');
      this.customerEmail = this.dataset.customerEmail;
      this.customerLastName = this.dataset.customerLastName;
      this.loggedIn = false;
      this.form.addEventListener('submit', this.doSearch.bind(this));

      if (this.customerEmail && this.customerLastName) {
        this.loggedIn = true;
        this.search(this.customerEmail, this.customerLastName);
      }
    }

    doSearch(e) {
      e.preventDefault();
      var formData = new FormData(this.form);
      var lastName = formData.get('last_name');
      var email = formData.get('email');
      var modelNumber = formData.get('model_number');

      this.form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });

      var error = false;
      var requiredFields = this.form.querySelectorAll('.required');
      for(var i = 0; i < requiredFields.length; i++) {
        if(requiredFields[i].value === '') {
          requiredFields[i].classList.add('error');
          error = true;
        }
      }

      if(error) {
        return;
      }

      this.search(email, lastName, modelNumber);
    }

    search(email, lastName, modelNumber = null) {
      $s.showLoadingOverlay();
      getRegisteredProducts(email, lastName).then((data) => {
        this.renderResults(data, modelNumber);
      }).catch((error) => {
        $s.hideLoadingOverlay();
        this.resultsContainer.innerHTML = '<p class="error">' + lngg.registration_lookup__error_message.replace('', this.esc(error.error || 'Unknown error')) + '</p>';
      });
    }

    renderResults(data, modelNumber = null) {
      $s.hideLoadingOverlay();
      
      if (data.success && data.data) {
        var registrations = data.data.itemRegistrations || [];
        
        if (registrations.length === 0) {
          this.resultsContainer.innerHTML = '<p class="text-center">' + lngg.registration_lookup__no_registrations_found_message + '</p>';
          return;
        }
        
        // Filter by model number if provided
        var filteredRegistrations = registrations;
        if (modelNumber) {
          filteredRegistrations = registrations.filter(function(registration) {
            var itemCode = (registration.item && registration.item.itemCode) || '';
            return itemCode.toLowerCase() === modelNumber.toLowerCase();
          });
        }

        if (filteredRegistrations.length === 0) {
          this.resultsContainer.innerHTML = '<p class="text-center">' + lngg.registration_lookup__no_registrations_found_matching_model_number_message.replace(new RegExp(/{{ *model_number* }}/), '<strong>' + this.esc(modelNumber) + '</strong>') + '</p>';
          return;
        }
        
        // Render all matching registrations
        var registrationsHtml = filteredRegistrations.map((registration) => {
          return this.renderRegistration(registration, data.data);
        }).join('');

        if(this.loggedIn) {
          this.resultsContainer.innerHTML = '<div class="h3">' + lngg.registration_lookup__logged_in_found_registrations_message.replace(new RegExp(/{{ *registrations_length* }}/), filteredRegistrations.length) + '</div>' + registrationsHtml;
        } else {
          this.resultsContainer.innerHTML = '<div class="h3">' + lngg.registration_lookup__logged_out_found_registrations_message.replace(new RegExp(/{{ *registrations_length* }}/), filteredRegistrations.length) + '</div>' + registrationsHtml;
        }
      
      } else {
        this.resultsContainer.innerHTML = '<p class="error">' + lngg.registration_lookup__error_message.replace(new RegExp(/{{ *error* }}/), this.esc(data.error || 'Unknown error')) + '</p>';
      }
      return;
    }

    renderRegistration(registration, customerData) {
      var item = registration.item || {};
      var html = this.template.innerHTML;
      html = html.replace(/__ITEM_IMAGE__/g, this.esc(item.mainImageUrl));
      html = html.replace(/__ITEM_NAME__/g, this.esc(item.itemName));
      html = html.replace(/__MODEL_NUMBER__/g, this.esc(item.itemCode));
      html = html.replace(/__FIRST_NAME__/g, this.esc(customerData.firstName));
      html = html.replace(/__LAST_NAME__/g, this.esc(customerData.lastName));
      html = html.replace(/__PURCHASE_DATE__/g, this.esc(this.formatDate(registration.purchaseDate)));
      html = html.replace(/__DATE_CREATED__/g, this.esc(this.formatDate(registration.dateCreated)));
      //concat the email to the item url and the registration id (URL-encode the parts)
      var itemUrl = '/pages/bom-product/' + encodeURIComponent(item.itemCode || '') +
        '?email=' + encodeURIComponent(customerData.email || '') +
        '&registrationId=' + encodeURIComponent(registration.id || '');
      html = html.replace(/__ITEM_URL__/g, this.esc(itemUrl));
      return html;
    }

    esc(v) {
      return String(v == null ? '' : v)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    formatDate(dateString) {
      if (!dateString || dateString === '0001-01-01T00:00:00') {
        return 'N/A';
      }
      var date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString;
      }
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }

  }
  customElements.define('registration-lookup', ComponentRegistrationLookup);
}